import { useEffect, useRef } from 'react';

// Llama a `funcion` ahora y cada `cadaMs`, solo con la pantalla visible.
export default function usePolling(funcion, cadaMs = 10000) {
  const guardada = useRef(funcion);

  useEffect(() => {
    guardada.current = funcion;
  });

  useEffect(() => {
    const correr = () => {
      if (document.visibilityState === 'visible') guardada.current();
    };

    correr();
    const id = setInterval(correr, cadaMs);
    document.addEventListener('visibilitychange', correr);

    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', correr);
    };
  }, [cadaMs]);
}
